import React, {useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from "framer-motion";
import { useGlobalContext } from '../../context';

function About() {
  const { t } = useTranslation();
  const {initial, final, animation1, animation2,animation3, setSectionRef, sectionRef} = useGlobalContext();
  const square1Ref = useRef(null);
  const square2Ref = useRef(null);
  const aboutRef = useRef(null);
  
  useEffect(() => {
    setSectionRef({ ...sectionRef, about: aboutRef });
  }, [setSectionRef, sectionRef, aboutRef]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      // Adjust these values based on your layout and design
      const moveFactor1 = 0.13; // Adjust the factor for the first square
      const moveFactor2 = 0.28; // Adjust the factor for the second square

      const square1 = document.querySelector('.about__position1');
      if (square1) {
        square1.style.transform = `translate(-36%, -${scrollPosition * moveFactor1}px)`;
      }

      const square2 = document.querySelector('.about__position2');
      if (square2) {
        square2.style.transform = `translate(40%, ${scrollPosition * moveFactor2}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section
    ref={aboutRef}
    id='about'
    className="section about">
      <div className="container about__container">
        <div className="about__inner_container">
          <div ref={square1Ref} className="about__square about__position1" />
          <div ref={square2Ref} className="about__square about__position2 hide-for-mobile" />
          <motion.h2
            initial={initial}
            whileInView={final}
            transition={animation1}
            viewport={{once: true}}
          >{t('about.h2')}</motion.h2>
          <div>
          <motion.p
            initial={initial}
            whileInView={final}
            transition={animation2}
            viewport={{once: true}}
          >{t('about.p')}</motion.p>
          <div className="div"><br/></div>
          <motion.p
            initial={initial}
            whileInView={final}
            transition={animation3}
            viewport={{once: true}}
          >{t('about.p1')}</motion.p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
